import React from "react";

import { Bike, Headphones, MapPin, ShieldCheck } from "lucide-react";

const features = [
  {
    id: 1,
    title: "Lightning-fast delivery",
    description:
      "Hot food at your door in 25 minutes or it is on us — guaranteed.",
    icon: Bike,
    iconColor: "#ff681d",
    iconBackground: "#fff1e8",
  },
  {
    id: 2,
    title: "Quality you can trust",
    description:
      "Every partner kitchen is inspected and rated for hygiene and taste.",
    icon: ShieldCheck,
    iconColor: "#09b981",
    iconBackground: "#e6faf3",
  },
  {
    id: 3,
    title: "Live Tracking",
    description: "Know exactly where your order is and when it will arrive.",
    icon: MapPin,
    iconColor: "#365494",
    iconBackground: "#e8edf8",
  },
  {
    id: 4,
    title: "24/7 support",
    description: "Anytime. Chat or call — we have got your back.",
    icon: Headphones,
    iconColor: "#ec62b0",
    iconBackground: "#fde8f5",
  },
];

export default function BuiltForFood() {
  return (
    <section className="w-full bg-blue-50 px-4 py-[54px] sm:px-5 md:px-8 md:py-[60px]">
      <div className="mx-auto w-full max-w-[1260px]">
        {/* Description */}
        <div className="mx-auto max-w-[620px] text-center">
          <h1 className="text-[30px] font-semibold leading-tight tracking-[-0.7px] text-[#1f2937] md:text-[36px]">
            Built for people who love food
          </h1>

          <p className="mx-auto mt-3 max-w-[610px] text-[14px] font-medium leading-[20px] text-gray-500 sm:text-[15px] md:text-[16px] md:leading-[21px]">
            We obsess over every detail so your next meal is effortless, fast,
            and exactly what you craved.
          </p>
        </div>

        {/* Feature cards */}
        <div className="mt-[46px] grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {features.map((feature) => {
            const Icon = feature.icon;

            return (
              <article
                key={feature.id}
                onMouseEnter={(event) => {
                  event.currentTarget.style.borderColor = feature.iconColor;
                }}
                onMouseLeave={(event) => {
                  event.currentTarget.style.borderColor = "transparent";
                }}
                className="min-h-[120px] rounded-[16px] border border-transparent bg-white p-3 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_14px_35px_rgba(255,255,255,0.12)]"
              >
                {/* Icon + Heading */}
                <div className="flex items-center gap-3">
                  <div
                    className="flex h-[44px] w-[44px] items-center justify-center rounded-[11px] shrink-0"
                    style={{
                      backgroundColor: feature.iconBackground,
                    }}
                  >
                    <div
                      className="flex h-[34px] w-[34px] items-center justify-center rounded-[8px]"
                      style={{
                        backgroundColor: feature.iconColor,
                      }}
                    >
                      <Icon
                        size={18}
                        strokeWidth={1.8}
                        className="text-white"
                      />
                    </div>
                  </div>

                  <h3 className="text-[18px] font-medium leading-[22px] text-[#505050]">
                    {feature.title}
                  </h3>
                </div>

                <p className="mt-[7px] text-[14px] leading-[21px] text-[#8fa0b8]">
                  {feature.description}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
